export function define(tagName, clazz) {
    const isClient = typeof window !== 'undefined';
    if (isClient && !customElements.get(tagName))
        customElements.define(tagName, clazz);
}
export function method(name) {
    return function proxy(...args) {
        return this.$refs.ref[name](...args);
    };
}
export function render(tagName, events) {
    return function proxy(createElement) {
        const self = this;
        const listeners = events.reduce((prevListeners, event) => (Object.assign(Object.assign({}, prevListeners), { [event]: ($event) => {
                var _a;
                let emittedValue = $event.detail;
                if ((_a = $event.detail) === null || _a === void 0 ? void 0 : _a.value)
                    emittedValue = $event.detail.value;
                self.$emit(event, emittedValue);
            } })), self.$listeners);
        return createElement(tagName, {
            ref: 'ref',
            domProps: Object.assign({}, self.$props),
            on: listeners,
        }, [self.$slots.default]);
    };
}
//# sourceMappingURL=lib.js.map